// extracted by mini-css-extract-plugin
export default {"active":"Send_active__ChYDl","inActive":"Send_inActive__fR+8i","box":"Send_box__xpJtS","iconWrapper":"Send_iconWrapper__Iq8FF","icon":"Send_icon__x0aVH","label":"Send_label__5HrCp"};